import { c as _c } from "react/compiler-runtime";
import { usePosthogCapture } from '@repo/sdk/analytics/posthog';
import { useSession } from '@repo/sdk/auth';
import { useForm, zodResolver } from '@repo/sdk/form';
import { useMutation } from '@repo/sdk/tanstack';
import { z } from '@repo/sdk/zod';
import { Button, Form, FormControl, FormField, FormItem, FormMessage, Input, Separator, Spinner, toast } from '@repo/ui/components';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { loginAction } from '@/app/_components/welcome-modal/action.ts';
import { useWelcomeModalContext } from '@/app/_components/welcome-modal/context.tsx';
import SocialButton from '../_components/social-button.tsx';
const LoginForm = () => {
  const $ = _c(49);
  const {
    email,
    setStep
  } = useWelcomeModalContext();
  const {
    posthogCapture
  } = usePosthogCapture();
  const session = useSession();
  let t0;
  if ($[0] !== posthogCapture) {
    t0 = () => posthogCapture("welcome: existing user enters login view");
    $[0] = posthogCapture;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  let t4;
  if ($[3] !== email) {
    const schema = z.object({
      email: z.string().email(),
      password: z.string().min(6, "Password is too short")
    });
    t4 = useForm;
    t2 = {
      email,
      password: ""
    };
    t3 = zodResolver(schema);
    $[3] = email;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3) {
    t5 = {
      defaultValues: t2,
      resolver: t3
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const form = t4(t5);
  const pathname = usePathname();
  const params = useSearchParams();
  let t6;
  if ($[10] !== params || $[11] !== pathname) {
    t6 = {
      mutationFn: async data => {
        await loginAction({
          ...data,
          redirectTo: `${pathname}?${params}`
        });
      },
      onError: _temp
    };
    $[10] = params;
    $[11] = pathname;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    isPending,
    mutate: register
  } = useMutation(t6);
  const [isLoading, setIsLoading] = useState(false);
  let t7;
  if ($[13] !== session?.data?.user || $[14] !== setStep) {
    t7 = () => {
      if (session?.data?.user?.id && session?.data?.user.phone) {
        window.dispatchEvent(new Event("onsubmitquoteform"));
        setIsLoading(true);
      } else {
        if (session?.data?.user?.id) {
          setStep("phone-number");
        }
      }
    };
    $[13] = session?.data?.user;
    $[14] = setStep;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = session?.data?.user;
  let t9;
  if ($[16] !== t8) {
    t9 = [t8];
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  useEffect(t7, t9);
  let t10;
  if ($[18] !== form || $[19] !== register) {
    let t11;
    if ($[21] !== register) {
      t11 = data_1 => register(data_1);
      $[21] = register;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    t10 = form.handleSubmit(t11);
    $[18] = form;
    $[19] = register;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  let t12;
  if ($[23] !== form.control) {
    t11 = <FormField control={form.control} name="email" render={_temp2} />;
    t12 = <FormField control={form.control} name="password" render={_temp3} />;
    $[23] = form.control;
    $[24] = t11;
    $[25] = t12;
  } else {
    t11 = $[24];
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link className="text-brand w-full justify-center text-center text-xs underline" href="/reset-password" target="_blank">Forgot password?</Link>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = isPending || isLoading;
  let t15;
  if ($[27] !== posthogCapture) {
    t15 = () => posthogCapture("welcome: existing user login attempt");
    $[27] = posthogCapture;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== isLoading || $[30] !== isPending) {
    t16 = (isPending || isLoading) && <Spinner />;
    $[29] = isLoading;
    $[30] = isPending;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t16) {
    t17 = <Button className="font-semibold" disabled={t14} onClick={t15} type="submit">LOG IN {t16}</Button>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Separator className="shrink" />;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex items-center gap-4">{t18}or<Separator className="shrink" /></div>;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t17) {
    t20 = <form className="flex flex-col gap-4" onSubmit={t10}>{t11}{t12}{t13}{t17}{t19}</form>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t17;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  let t22;
  let t23;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SocialButton source="google" />;
    t22 = <SocialButton source="microsoft" />;
    t23 = <SocialButton source="apple" />;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t21 = $[43];
    t22 = $[44];
    t23 = $[45];
  }
  let t24;
  if ($[46] !== form || $[47] !== t20) {
    t24 = <Form {...form}>{t20}{t21}{t22}{t23}</Form>;
    $[46] = form;
    $[47] = t20;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  return t24;
};
export default LoginForm;
function _temp(data_0) {
  console.warn(data_0);
  toast.error("Invalid email or password");
}
function _temp2(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Input {...field} placeholder="E-mail" /></FormControl><FormMessage /></FormItem>;
}
function _temp3(t0) {
  const {
    field: field_0
  } = t0;
  return <FormItem><FormControl><Input {...field_0} placeholder="Password" type="password" /></FormControl><FormMessage /></FormItem>;
}